import account from './account';
import incentives from './incentives';
import personalized from './personalized';
import testParams from './testparams';
import hasdata from './hasdata';

const root = {
	account,
	incentives,
	personalized,
	testParams,
	hasdata
};

export default root;
